import { inject, reactive, watch, nextTick, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { languageService } from '@/utils';
import { gaService } from "@/utils";
import { getGettingStarted, getPipeline } from "@/api";
export default {
  name: "sidebar",
  setup() {
    const {
      gaTrackButtonClick
    } = gaService;
    const {
      getLanguagePath
    } = languageService;
    const currentLangPath = computed(() => getLanguagePath());
    const route = useRoute();
    const router = useRouter();
    const {
      sidebar
    } = inject("store");
    const state = reactive({
      activeLink: null,
      sidebarCloseWidth: 64,
      sidebarOpenWidth: 265
    });
    const getDefaultActiveLink = route => {
      //detail page 
      if (route.query.v) {
        return '';
      }

      //other page
      let routePath = route.path.replace(currentLangPath.value, "").split('/')[0];
      if (routePath && routePath.toLowerCase() !== 'home') {
        return routePath;
      } else {
        return "home";
      }
    };
    const routerPush = element => {
      let path = currentLangPath.value;
      if (element.index != "home") {
        path += element.index;
      }
      router.push(path);
    };
    const isGettingStartedOpen = ref(true);
    const isPipelineOpen = ref(true);
    const openSidebar = () => {
      const currentStatus = sidebar.states.isSidebarClose;
      sidebar.mutations.switchUserClose(currentStatus);
      sidebar.mutations.switchSidebarClose(currentStatus);
    };
    const toggleGettingStarted = () => {
      isGettingStartedOpen.value = !isGettingStartedOpen.value;
    };
    const togglePipeline = () => {
      isPipelineOpen.value = !isPipelineOpen.value;
    };
    const goGettingStarted = url => {
      closeSidebar();
      gaTrackButtonClick("leftmenu-getting-started");
      if (!url) {
        return;
      }
      try {
        const target = new URL(url, window.location.origin);
        if (target.origin === window.location.origin) {
          router.push(target.pathname + target.search + target.hash);
        } else {
          window.open(url, "_blank");
        }
      } catch (error) {
        window.open(url, "_blank");
      }
    };
    const goPipeline = urlName => {
      closeSidebar();
      gaTrackButtonClick("leftmenu-pipeline");
      router.push(currentLangPath.value + "pipeline/" + urlName);
    };
    const isPipelineRoute = computed(() => {
      return route.path.replace(currentLangPath.value, "").split("/")[0] === "pipeline";
    });
    const isPipelineActive = urlName => {
      return route.params.urlName === urlName && isPipelineRoute.value;
    };
    Promise.all([getGettingStarted(), getPipeline()]).then(([gettingStarted, pipeline]) => {
      sidebar.mutations.setGettingStartedList(gettingStarted);
      sidebar.mutations.setPipelineList(pipeline);
    }).catch(error => {
      console.log(error);
    });
    const switchWindowScrollbar = () => {
      if ($(window).width() <= 1312 && !sidebar.states.isSidebarClose) {
        $('body').addClass("stop-scroll");
      } else {
        $('body').removeClass("stop-scroll");
      }
    };
    const closeSidebar = () => {
      if ($(window).width() <= 1312) {
        sidebar.mutations.switchSidebarClose(false);
        sidebar.mutations.switchUserClose(false);
      }
    };
    watch(route, to => {
      state.activeLink = getDefaultActiveLink(to);
      bindResize();
    });
    watch(() => sidebar.states.isSidebarClose, () => {
      switchWindowScrollbar();
    });
    nextTick(() => {
      $('#fill-sidebar-gap').css('width', $('#sidebar').width());
      state.activeLink = getDefaultActiveLink(route);
    });
    let originalWidth = $(window).width();
    const checkWindowWidthToSwitchSidebar = () => {
      if (sidebar.states.isUserClose === null) {
        if ($(window).width() <= 1312 && !sidebar.states.isSidebarClose) {
          sidebar.mutations.switchSidebarClose(false);
        } else if ($(window).width() > 1312 && sidebar.states.isSidebarClose) {
          sidebar.mutations.switchSidebarClose(true);
        }
      } else {
        if (sidebar.states.isUserClose) {
          sidebar.mutations.switchSidebarClose(false);
        } else if (originalWidth > 1312 && $(window).width() < 1312) {
          sidebar.mutations.switchSidebarClose(false);
        } else if (originalWidth < 1312 && $(window).width() > 1312) {
          sidebar.mutations.switchSidebarClose(true);
        }
      }
      originalWidth = $(window).width();
      setTimeout(() => {
        switchWindowScrollbar();
      }, 0);
    };
    let checkWindowWidthToCloseSidebarTimer = null;
    const ResizeEvent = function () {
      clearTimeout(checkWindowWidthToCloseSidebarTimer);
      checkWindowWidthToCloseSidebarTimer = setTimeout(() => {
        checkWindowWidthToSwitchSidebar();
      }, 250);
    };
    const bindResize = () => {
      window.removeEventListener("resize", ResizeEvent);
      window.addEventListener("resize", ResizeEvent, false);
    };
    bindResize();
    checkWindowWidthToSwitchSidebar();
    return {
      sidebar,
      state,
      closeSidebar,
      gaTrackButtonClick,
      currentLangPath,
      routerPush,
      isGettingStartedOpen,
      isPipelineOpen,
      openSidebar,
      toggleGettingStarted,
      togglePipeline,
      goGettingStarted,
      goPipeline,
      isPipelineActive,
      isPipelineRoute
    };
  }
};